<template>
  <div class="container__flex container__wrapper">
    <slot />
  </div>
</template>

<script>
export default {}
</script>
